import React, { useState } from "react";
import MainCalculatorsList from "./MainCalculators";
import SharedHelmet from "../Helmet";
import RelatedLinks from "../RelatedLinks";
import { FirstAds, SecondAds, MobileUnderCalAds } from "../../Ads";

const TITLE = "Calculatrice de solubilité - Calculez la solubilité dans l'eau";
const DESCRIPTION =
  "Calculatrice de solubilité - Calculez la solubilité dans l'eau. Calculateur de chimie en francais pour cours et TP, avec saisie simple, resultat rapide et interpretation claire.";
const KEYWORDS =
  "solubility calculator, calculatrice chimie, formule de chimie, tp de chimie, calcul en ligne";
const OG_URL = "https://do-calculate.com/calculator/fr/solubility-calculator/";

function SolubilityCalculator() {
  const [firstValue, setFirstValue] = useState(0);
  const [secondValue, setSecondValue] = useState(0);
  const [result, setResult] = useState();
  const [steps, setSteps] = useState("");
  const [error, setError] = useState("");

  const handleCalculate = () => {
    try {
      if (firstValue && secondValue) {
        const solubility = (parseInt(firstValue) * 100) / parseInt(secondValue);
        setResult(solubility.toFixed(2));
        setSteps(`Pour calculer la solubilité:
        \n1. Nous multiplions la masse de la substance dissoute par 100: ${firstValue} × 100 = ${
          firstValue * 100
        }
        \n2. Nous divisons le résultat par la masse de l'eau (le solvant): ${
          firstValue * 100
        } ÷ ${secondValue} = ${solubility.toFixed(2)}`);
        setError("");
      } else {
        setError(
          "Veuillez entrer toutes les valeurs requises pour effectuer l'opération de calcul!"
        );
      }
    } catch (error) {
      setError(error.message);
    }
  };

  return (
    <div className="ltr">
      <SharedHelmet
        TITLE={TITLE}
        DESCRIPTION={DESCRIPTION}
        KEYWORDS={KEYWORDS}
        OG_URL={OG_URL}
      />
      <div className="row">
        <div className="col-12 col-md-8">
          <FirstAds />
        </div>
      </div>
      <div className="row">
        <div className="col-12 col-md-8">
          <br />
          <div
            className="bg-success text-white text-center"
            style={{ height: "50px" }}
          >
            <h1 style={{ fontSize: "17px" }}>{TITLE}</h1>
          </div>
          <div className="border border-light">
            <div className="row">
              <div>
                <p>
                  Cette calculatrice calcule la solubilité en utilisant l'équation suivante:
                </p>
                <p>
                  <strong>
                    Solubilité = Masse de la substance dissoute * 100 / Masse du solvant
                  </strong>
                </p>
                <ul>
                  <li>
                    Entrez la masse de la substance solide que vous souhaitez dissoudre.
                  </li>
                  <li>Entrez la masse d'eau utilisée (le solvant).</li>
                </ul>
                <p>
                  Cette calculatrice a été développée pour vous aider à comprendre dans quelle mesure une substance particulière peut se dissoudre dans l'eau, ce qui vous aide à déterminer le type de solution résultant.
                </p>
                <hr />
              </div>
              <br />
            </div>
            <MobileUnderCalAds />
            <div className="row">
              <div className="col-sm-12 col-md-7 calculatorStyle">
                <div className="p-3 mb-2 bg-success text-white">
                  <h2 style={{ fontSize: "16px" }}>{TITLE}</h2>
                </div>
                <div dir="ltr">
                  <div>
                    <hr />
                    <div className="form-group" htmlFor="firstValue">
                      <label className="form-label ms-2">
                        Entrez la masse de la substance dissoute (en grammes)
                      </label>
                      <input
                        id="firstValue"
                        type="number"
                        value={firstValue}
                        onChange={(e) => setFirstValue(e.target.value)}
                        placeholder="Entrez la masse de la substance dissoute"
                        className="form-control"
                        style={{ width: "75%" }}
                      />
                    </div>
                    <div className="form-group" htmlFor="secondValue">
                      <label className="form-label ms-2">
                        Entrez la masse de l'eau (en grammes)
                      </label>
                      <input
                        id="secondValue"
                        type="number"
                        value={secondValue}
                        onChange={(e) => setSecondValue(e.target.value)}
                        placeholder="Entrez la masse de l'eau"
                        className="form-control"
                        style={{ width: "75%" }}
                      />
                    </div>
                    <br />
                    <button
                      className="btn btn-success"
                      style={{ fontSize: "20px", marginLeft: "10px" }}
                      onClick={handleCalculate}
                    >
                      Calculer
                    </button>
                  </div>
                  <br />
                  {error !== "" && (
                    <p className="p-3 mb-2 bg-warning text-black">
                      Erreur: {error}
                    </p>
                  )}
                  {result && (
                    <div className="p-3 mb-2 bg-success">
                      <h4 className="text-white">Résultat:</h4>
                      <p className="text-white">{result}</p>
                      <div
                        className="p-3 mb-2 bg-info text-black"
                        style={{ width: "100%" }}
                      >
                        <h4 style={{ color: "black" }}>Étapes de la solution:</h4>
                        <p
                          className="text-black"
                          style={{ whiteSpace: "pre-line" }}
                        >
                          {steps}
                        </p>
                      </div>
                    </div>
                  )}
                  <hr />
                </div>
              </div>
            </div>
            <hr />
            <div className="row">
              <RelatedLinks />
              <hr />
            </div>
          </div>
        </div>
        <div className="col">
          <SecondAds />
          <br />
          <MainCalculatorsList></MainCalculatorsList>
          <br />
        </div>
      </div>
    </div>
  );
}

export default SolubilityCalculator;
